import { render } from "./CadastrarParceiro.vue?vue&type=template&id=127754a4&scoped=true"
import script from "./CadastrarParceiro.vue?vue&type=script&lang=js"
export * from "./CadastrarParceiro.vue?vue&type=script&lang=js"

import "./CadastrarParceiro.vue?vue&type=style&index=0&id=127754a4&scoped=true&lang=css"
import "./CadastrarParceiro.vue?vue&type=style&index=1&id=127754a4&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127754a4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTable,QImg,QTr,QTd,QCard,QIcon,QScrollArea,QInput,QField});
